module.exports = __webpack_public_path__ + "img/waves.ff73ed70.png";